document.addEventListener('DOMContentLoaded', () => {

  const pickers = document.querySelectorAll('variant-image-picker');

  pickers.forEach((picker) => {

    const cards = picker.querySelectorAll('.variant-image-card');

    // ======================
    // ACTIVE STATES
    // ======================

    function setActive(card, button = null) {

      cards.forEach(c => {
        c.classList.remove('active');
      });

      card.classList.add('active');

      const sizeButtons = picker.querySelectorAll(
        '.variant-size-option'
      );

      sizeButtons.forEach(btn => {
        btn.classList.remove('active');
      });

      if (button) {
        button.classList.add('active');
      }

      const label = picker.querySelector(
        '.selected-variant-name'
      );

      if (label) {
        label.textContent = card.dataset.colorValue;
      }

    }

    // ======================
    // GO TO VARIANT
    // ======================

    function goToVariant(variantId) {

      const url = new URL(window.location.href);

      url.searchParams.set('variant', variantId);

     document.body.classList.add('variant-loading');

setTimeout(() => {
  window.location.href = url.toString();
}, 120);

    }

    // ======================
    // SIZE BUTTONS
    // ======================

    const sizeButtons = picker.querySelectorAll(
      '.variant-size-option'
    );

    sizeButtons.forEach((button) => {

      button.addEventListener('click', (e) => {

        e.stopPropagation();

        const variantId = button.dataset.variantId;

        const card = button.closest(
          '.variant-image-card'
        );

        setActive(card, button);

        goToVariant(variantId);

      });

    });

    // ======================
    // COLOR CARDS
    // ======================

    cards.forEach((card) => {

      card.addEventListener('click', () => {

        const firstSize = card.querySelector(
          '.variant-size-option'
        );

        // PRODUCTS WITH SUBVARIANTS
        if (firstSize) {

          firstSize.click();

        }

        // COLOR ONLY PRODUCTS
        else {

          const variantId = card.dataset.variantId;

          setActive(card);

          goToVariant(variantId);

        }

      });

    });

  });

});